import * as React from "react";
const SvgFiRrHouseLeave = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-house-leave_svg__a)">
      <path
        fill="#062147"
        d="M15.054 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 15H4c-1.103 0-2-.897-2-2V7.662c0-.929.419-1.79 1.151-2.362l3.324-2.601c1.062-.831 2.503-.933 3.621-.287l1.418.926a1 1 0 0 0 1.093-1.675L11.143.708a5.26 5.26 0 0 0-5.901.415L1.918 3.724A4.97 4.97 0 0 0 0 7.662V13c0 2.206 1.794 4 4 4h4a1 1 0 0 0 0-2M5 9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm18.838 5.046a1 1 0 0 1-1.384.292l-2.399-1.564v3.867l.654.432a3 3 0 0 1 1.346 2.502V23a1 1 0 0 1-2 0v-3.425a1 1 0 0 0-.449-.834l-4.25-2.81a3.01 3.01 0 0 1-1.302-2.473V9.66l-1.564 1.069a1 1 0 0 0-.436.826v2.444a1 1 0 0 1-2 0v-2.444c0-.992.489-1.918 1.308-2.477l3.241-2.215c.301-.273 1.105-.847 2.547-.847 1.227 0 2.464.875 2.843 2.001.012.034.699 2.488.699 2.488a1 1 0 0 0 .417.568l2.438 1.589c.462.302.593.921.292 1.384zm-5.784-5.498c-.146-.266-.57-.532-.904-.532-.599 0-.941.153-1.096.248v5.193c0 .326.16.632.427.82l1.573 1.04zm-2.48 9.527a1 1 0 0 0-1.305.546l-1.641 4a1.001 1.001 0 0 0 1.851.759l1.641-4a1 1 0 0 0-.546-1.305"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-house-leave_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHouseLeave;
